import { render, staticRenderFns } from "./UnsubscribeModal.vue?vue&type=template&id=fc75f04c&scoped=true&"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeModal.vue?vue&type=style&index=0&id=fc75f04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc75f04c",
  null
  
)

export default component.exports